<template>
  <v-row v-if="isMounted && !value">
    <v-col align="center">
      <v-progress-circular
        :size="80"
        color="red-darken-2"
        indeterminate
      ></v-progress-circular>
    </v-col>
  </v-row>

  <v-row v-else-if="shownItems && !shownItems.length">
    <v-col>
      <v-alert color="info" type="info">
        We’re sorry, there are no matching resources.
      </v-alert>
    </v-col>
  </v-row>

  <v-row>
    <template v-if="shownItems && shownItems.length">
      <template v-for="item in shownItems" :key="item.id">
        <v-col cols="12" sm="6" md="4" xl="2">
          <ResourceCard :value="item" />
        </v-col>
      </template>
    </template>
  </v-row>

  <v-row v-if="showAllButton && hasMore">
    <v-col>
      <v-btn color="primary" block size="large" @click="isAllShown = true"
        >Show All</v-btn
      ></v-col
    >
  </v-row>

  <slot name="footer" :shown="shownItems && shownItems.length" />
</template>

<script setup>
import { computed, ref } from 'vue'
import { useMounted } from '@vueuse/core'

const props = defineProps({
  all: {
    default: false,
    type: Boolean
  },
  facetKeys: {
    default: undefined,
    type: Array
  },
  limit: {
    default: 10000,
    type: Number
  },
  showAllButton: {
    default: false,
    type: Boolean
  },
  value: {
    default: undefined,
    type: Object
  }
})

const isAllShown = ref(false)
const isMounted = useMounted()
const filteredItems = computed(() => {
  const facetKeys = props.facetKeys
  const items = props.value && props.value.data

  if (!(facetKeys && items)) return []

  return facetKeys.map(i => items[i])
})
const shownItems = computed(() => {
  return props.all || isAllShown.value
    ? filteredItems.value
    : filteredItems.value.slice(0, props.limit)
})
const hasMore = computed(() => {
  return (
    filteredItems.value &&
    shownItems.value &&
    filteredItems.value.length > shownItems.value.length
  )
})
</script>
